import React from 'react';
import { useHistory } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import QrCodeReader from '../../qrCodeReader';
import {
  INotificationModalProps,
  NotificationModal,
  useModal,
} from '../../modals';
import attemptVisitorSignOut from './attemptVisitorSignOut';

export interface ISignOutResult {
  success: boolean;
  message: string;
}

export const VisitorSignOutPage: React.FC = () => {
  const history = useHistory();

  const { showModal, hideModal } = useModal();

  const showMessage = (signOutResult: ISignOutResult) => {
    const notificationProps: INotificationModalProps = {
      title: signOutResult.success ? 'Signed out' : 'Sign out failed',
      message: signOutResult.success
        ? 'Thank you for signing out'
        : signOutResult.message,
      icon: ['far', signOutResult.success ? 'check-circle' : 'times-circle'],
      kind: signOutResult.success ? 'success' : 'danger',
      timeout: 2000,
      onRequestClose: () => {
        hideModal();
        history.replace('/visitor');
      },
    };

    showModal(NotificationModal, notificationProps);
  };

  const handleSignOut = (badgeNumber: string) => {
    attemptVisitorSignOut(badgeNumber)
      .then(({ data }: { data: ISignOutResult }) => {
        showMessage(data);
      })
      .catch((error) => console.log(error));
  };

  return (
    <Container>
      <h1>Sign Out</h1>
      <QrCodeReader backUrl="/visitor" onSuccess={handleSignOut} />
    </Container>
  );
};
